import { Link } from "react-router-dom";
import moment from "moment";
import projectsStyles from "../../styles/projects.module.scss";
import { IProjectsData } from "@/api/projects/types";
import IcoProject from "../../assets/ico-project.svg?react";
import UIcon from "@/assets/uicons/UIcon";

const getAvatarColor = (seed: string | number) => {
  const colors = [
    '#A9DCD9', '#FFC7D8', '#F8DF72', '#B5B8F8', '#B6E3A8',
    '#FFD6A5', '#C3B6F8', '#F9AAEF'
  ];
  const stringSeed = String(seed);
  const hash = Array.from(stringSeed).reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const index = Math.abs(hash % colors.length);
  return colors[index];
}

interface Props {
  project: IProjectsData;
  viewMode?: "list" | "grid";
  onEdit: (project: IProjectsData) => void;
}

const ProjectsList = ({ project, viewMode = 'list', onEdit }: Props) => {
  const avatarColor = getAvatarColor(project.id || project.name);

  return (
    <div className={
      viewMode === 'grid'
        ? `${projectsStyles["project-row"]} ${projectsStyles["project-row-grid"]}`
        : projectsStyles["project-row"]
    }>
      <div className={projectsStyles["project-avatar"]} style={{ background: avatarColor }}>
        <IcoProject className={projectsStyles["project-avatar-icon"]} height={"32"} />
      </div>
      <div className={projectsStyles["project-info"]}>
        <Link to={`/projects/${project.id}`} className={projectsStyles["project-name"]}>
          {project.name}
        </Link>
        <span className={projectsStyles["project-date"]}>{moment(project.startDate).fromNow()}</span>
      </div>
      <div className={projectsStyles["project-dates"]}>
        <span>{moment(project.startDate).format("DD MMM.YYYY")}</span>
        <span>{moment(project.endDate).format("DD MMM.YYYY")}</span>
      </div>
      <button 
        className={projectsStyles["project-edit"]} 
        name="editProject" 
        onClick={() => onEdit(project)}
        aria-label="Editar proyecto"
      >
        <UIcon 
          name="editPencil" 
          size={18} 
          className={projectsStyles["project-edit-icon"]}
        />
      </button>
    </div>
  );
};

export default ProjectsList;
